import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GLOBAL } from '../../app.globals';
import { HrClearanceService } from '../hr-clearance.service';
import { LogHelperService } from '../../core/services/log-helper.service';

const ALLOWED_ROLES = [108, 116, 117, 118, 120];

@Component({
  selector: 'app-hrc-submission-allow-cell-renderer',
  template: `
    <ng-container *ngIf="!params?.data?.parent">
      <div style="padding: 5px; padding-left: 15px;" [title]="isAllowed ? 'Allowed' : 'Not Allowed'"
        [style.cursor]="canUpdate && !isAllowed ? 'pointer' : 'default'"
        (click)="onToggle()">
        <i class="fa fa-arrow-right" [style.color]="isAllowed ? 'green' : 'gray'"></i>
      </div>
    </ng-container>
  `
})
export class HrcSubmissionAllowCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  isAllowed = false;
  canUpdate = false;

  constructor(
    private hrClearanceService: HrClearanceService,
    private logHelperService: LogHelperService
  ) {}

  agInit(params: any): void {
    this.params = params;
    this.isAllowed = params.data && params.data.IsSubmitAllow === 1;
    this.canUpdate = ALLOWED_ROLES.includes(Number(GLOBAL.ROLE_CODE));
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }

  onToggle(): void {
    if (this.isAllowed) return;
    this.logHelperService.confirmationBox(
      { title: 'Are you sure?', message: 'HR allow for HRC request?' },
      'warning',
      'Yes'
    ).then((result) => {
      if (!result.value) return;
      const requestObj = {
        PayrollMonth_Code: this.params.data.PayrollMonth_Code || null,
        WorkOrder_Code: this.params.data.WorkOrderCode || null,
        HRC_Code: this.params.data.HRCCode,
        ActionType: 1,
        RequestType: 1,
        UserID: GLOBAL.USER_ID
      };
      this.hrClearanceService.updateHRCSubmissionAllow(requestObj).subscribe(
        () => {
          this.isAllowed = true;
          this.params.data.IsSubmitAllow = 1;
          this.params.api.refreshCells({ rowNodes: [this.params.node], force: true });
        },
        () => this.logHelperService.logError({ message: 'Failed to update submission allow status.' })
      );
    });
  }
}
